module.exports = __webpack_public_path__ + "static/6013-San-Bernard-Plan-700x1024-5721df1f64de9134a245fe4c667f7ddc.jpg";